module.exports = __webpack_public_path__ + "static/media/emilie.60e9a94f.png";